export default __webpack_public_path__ + "static/media/cloud-3.16ae829c.webp";